import { Form, Row, Col, Button, InputGroup, Alert} from "react-bootstrap"
import BreadcrumbEstadistica from "./BreadcrumbEstadistica";
import MaoTable from "../common/MaoTable";
import {getVentas} from '../../services/EstadisticaService'
import ReporteVentasChartJS from "./ReporteVentasChartJS";
import { useNavigate} from "react-router-dom"
import { useState, useEffect } from "react";
import { formatNumber } from "../../utils/NumberUtils";
import { getFechaInicioMes, getFechaHoy } from "../../utils/DateUtils";

function EstadisticasForm() {

  const [ventas, setVentas] = useState([]);
  const [error, setError] = useState("");
  const [totales, setTotales] = useState({});
  const [fechaDesde, setFechaDesde] = useState(getFechaInicioMes());
  const [fechaHasta, setFechaHasta] = useState(getFechaHoy());
  const [mostrarGraficas, setmostrarGraficas] = useState(false);

  const navigate = useNavigate();

  function volver () {
    navigate("/estadistica");
  }
  
  //cualquier cosa, volver a poner el async
  async function buscar ()  {
    setmostrarGraficas(true)
    let fechaDesde = document.getElementById('fechaDesde').value;
    let fechaHasta = document.getElementById('fechaHasta').value;
    let pendientesParam = document.getElementById('chkIncluirPendientes').checked;
    let resp = await getVentas(fechaDesde, fechaHasta, pendientesParam);
    if (resp.error) {
      setError(resp.message);
      setVentas([]);
    } else {
      setError("");
      setVentas(resp.data);
      let total_ventas = 0;
      let total_comisiones = 0;
      let total_clientes_activos = 0;
      for (let i=0; i<resp.data.length; i++) {
        total_ventas += parseFloat(resp.data[i].ventas);
        total_comisiones += parseFloat(resp.data[i].comisiones);
        total_clientes_activos += parseInt(resp.data[i].clientes_activos);
      }
      setTotales({
        marca: "Total",
        ventas: formatNumber(total_ventas),
        comisiones: formatNumber(total_comisiones),
        clientes_activos: total_clientes_activos
      })
    }
  }

   // Efecto para inicializar las fechas cuando se monta el componente
   useEffect(() => {
    async function ventasInicio () {
      setmostrarGraficas(true)
      let resp = await getVentas(fechaDesde, fechaHasta)
      if (resp.error) {
        setError(resp.message);
        setVentas([]);
      } else {
        setError("")
        setVentas(resp.data)
        let total_ventas = 0;
        let total_comisiones = 0;
        let total_clientes_activos = 0;
        for (let i=0; i<resp.data.length; i++) {
          total_ventas += parseFloat(resp.data[i].ventas);
          total_comisiones += parseFloat(resp.data[i].comisiones);
          total_clientes_activos += parseInt(resp.data[i].clientes_activos);
        }
        setTotales({
          marca: "Total",
          ventas: formatNumber(total_ventas),
          comisiones: formatNumber(total_comisiones),
          clientes_activos: total_clientes_activos
        })
      }
    }
    ventasInicio()
    
  }, []);

  // Función para manejar el cambio de la fecha "desde"
  const handleFechaDesdeChange = (e) => {
    e.preventDefault();
    setmostrarGraficas(false)
    setFechaDesde(e.target.value);
  };

  // Función para manejar el cambio de la fecha "hasta"
  const handleFechaHastaChange = (e) => {
    e.preventDefault();
    setmostrarGraficas(false)
    setFechaHasta(e.target.value);
  };
  
  

  const columnas = [
    {
        titulo:"Marca",
        atributo:"marca",
        className:"text-truncate"
    },{
        titulo:"Ventas",
        atributo:"ventas",
        className:"text-truncate max-width-20-em col-importe",
        funcion: formatNumber
    },{
        titulo:"Comisiones",
        atributo:"comisiones",
        className:"text-truncate max-width-20-em col-importe",
        funcion: formatNumber
    },{
        titulo:"Cant. Clientes",
        atributo:"clientes_activos",
        className:"text-truncate max-width-20-em col-importe"
    }
  ]
  
  return (
    <div>
      <BreadcrumbEstadistica active="Resultado de Ventas"/>
      <Form >
        <Row className="d-flex align-items-center">
          <Col xs="auto" md="3">
            <InputGroup className="mb-2">
              <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Desde</InputGroup.Text>
              <Form.Control 
                type="date" 
                id="fechaDesde" 
                value={fechaDesde} 
                onChange={handleFechaDesdeChange}
                placeholder="Fecha Desde..."
              />
            </InputGroup>
          </Col>
          <Col xs="auto" md="3">
            <InputGroup className="mb-2">
              <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Hasta</InputGroup.Text>
              <Form.Control 
                type="date" 
                id="fechaHasta"
                value={fechaHasta} 
                onChange={handleFechaHastaChange}
                placeholder="Fecha Hasta..."
              />
            </InputGroup>
          </Col>
          <Col xs="auto">
            <Form.Check
              type="checkbox"
              id="chkIncluirPendientes"
              label="Incluir Pendientes"
              onClick={buscar}
            />
          </Col>
          <Col xs="auto" sm="3" md="3">
            <InputGroup className="mb-2">
              <Button onClick={buscar}>Buscar</Button>
            </InputGroup>
          </Col>
        </Row>
        {error!==''?
            <Row>
                <Col xs="auto">
                    <Alert variant="danger" key="danger">{error}</Alert>
                </Col>
            </Row>:
            <></>
        }
      </Form>
      <MaoTable 
        columnas={columnas}
        datos={ventas}
        colId="marca"
        totales={totales}
      />
      { mostrarGraficas ? <ReporteVentasChartJS ventas={ventas}/> : 
        <div className="error" >Presione Buscar para actualizar</div>
      }
      <div className="d-flex justify-content-center">
        <Button onClick={volver}>Volver</Button>
      </div>
    </div>
  )
}

export default EstadisticasForm